<template>
  <div class="base-box">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <p>标注<span style="color: red"> “ * ” </span>的填写项为必填项,如空缺则不能完成注册。</p>
        <div class="fontBox">
            <!-- <div style="margin-top:20px">
                <table>
                    <thead>
                        <tr>
                            <td>关注分会</td>
                            <td>分会职务</td>
                        </tr>
                    </thead>
                </table>
                <memberPostTable ref="memberPostTable" :memberId="infos.id"> </memberPostTable>
            </div> -->
            <advanced-form
                ref="advForm"
                :initFields="fields"
                :formData.sync="member"
                :allDictionary="allDictionary"
                :allAddress="cityList"
                :branchsList="branchsList"
                :customDataList="customDataList"
            ></advanced-form>
        </div>
        <div class="buttonBox">
            <van-button type="primary" size="large" plain @click="saveZc()">保存</van-button>
            <van-button type="primary" size="large" @click="save()">提交</van-button>
        </div>

    <!-- <van-tabs v-model="active">
    <van-tab title="基本资料">
    </van-tab>
    <van-tab title="研究项目">
        <div class="fontBox">
            <researchProjects></researchProjects>
        </div>
    </van-tab>
    <van-tab title="获奖信息">内容 3</van-tab>
    <van-tab title="发表论文">内容 4</van-tab>
    <van-tab title="专注情况">内容 4</van-tab>
    </van-tabs> -->
  </div>
</template>
<script>
import memberPostTable from "../../components/memberPostTable";
import researchProjects from "../../views/register/grmember/researchProjects.vue";
import AdvancedForm from "../../components/AdvancedForm.vue";
import vHead from "../../components/Subhead.vue";
import {
  findFileById,
  getBranchs,
  getSingleRegisterSetting,
  saveMembers,
} from "@/api/dictionary";
import {
  registerMemberEdit,
} from "@/api/login";
import {
  Field,
  NavBar,
  Button,
  Toast,
  Tab,
  Tabs,
  Dialog
} from "vant";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      //   fileList: [],
      //   fileList2: [],
      active:0,
      title: "入会申请表",
      //   porName:"",
      //   jgName: "",
      //   addName: "",
      show: false,
      // areaList,
      allAddress: [],
      items: [],
      addrItems: [],
      titleId: null,
      cityId: null,
      activeId: null,
      activeIndex: null,
      infos: {},
      changeData: {},
      //   fields: [
      //       {
      //           "id": "bb791ee4-dd0d-44af-ac67-7ada359cd109",
      //           "tid": "0",
      //           "schemaId": "33b41c2a-d3df-4383-96bd-506edd4f852b",
      //           "field": null,
      //           "fieldCaption": "",
      //           "fieldType": null,
      //           "fieldLength": null,
      //           "editorType": 9,
      //           "description": "单位类型",
      //           "dictionaryId": null,
      //           "seq": 1,
      //           "display": 1,
      //           "readonly": 0,
      //           "nullable": 0,
      //           "checkRule": null,
      //           "displayFormat": null,
      //           "editorWidth": 4,
      //           "editorGroup": 1
      //       },
      //       {
      //           "id": "9e5969b9-9e8c-4070-b765-0e60f4e77f69",
      //           "tid": "0",
      //           "schemaId": "33b41c2a-d3df-4383-96bd-506edd4f852b",
      //           "field": "groupType",
      //           "fieldCaption": "单位类型",
      //           "fieldType": 4,
      //           "fieldLength": 11,
      //           "editorType": 4,
      //           "description": "单位类型",
      //           "dictionaryId": "GROUP_TYPE",
      //           "seq": 2,
      //           "display": 1,
      //           "readonly": 0,
      //           "nullable": 0,
      //           "checkRule": null,
      //           "displayFormat": null,
      //           "editorWidth": 6,
      //           "editorGroup": 1
      //       },
      //       {
      //           "id": "51b5ccd7-1d8d-4730-b172-4e39f666c31e",
      //           "tid": "0",
      //           "schemaId": "33b41c2a-d3df-4383-96bd-506edd4f852b",
      //           "field": "name",
      //           "fieldCaption": "真实姓名",
      //           "fieldType": 5,
      //           "fieldLength": 64,
      //           "editorType": 1,
      //           "description": "真实姓名",
      //           "dictionaryId": null,
      //           "seq": 7,
      //           "display": 1,
      //           "readonly": 0,
      //           "nullable": 0,
      //           "checkRule": null,
      //           "displayFormat": null,
      //           "editorWidth": 1,
      //           "editorGroup": 3
      //       }
      //     ],
      //   request: {
      //     recommendUnitId: "请选择单位",
      //     concernUnitId: "请选择关注单位",
      //     portraitId: "请上传2寸证件照",
      //     memberType: "请选择会员类型",
      //     name: "请输入您的姓名",
      //     gender: "请选择您的性别",
      //     birthday: "请选择您的出生年月",
      //     partisan: "请选择您的政治面貌",
      //     company: "请输入您的工作单位",
      //     // socialTenure: "请输入您的社会任职",
      //     title: "请选择您的职称",
      //     education: "请选择您的学历",
      //     degree: "请选择您的学位",
      //     // idType: "请选择证件类别",
      //     idNumber: "请输入证件号码",
      //     nationality: "请选择您的民族",
      //     // nativeProvince: "请选择您的籍贯",
      //     // nativeCity: "请选择您所在的城市",
      //     fullAddress: "请输入您的详细地址",
      //     email: "请输入您的常用邮箱",
      //     mobile: "请输入您的手机号码",
      //       zipcode: "请输入您的邮政编码"
      //   },
      params: {
        memberType: null,
        name: "",
        code: "",
        gender: null,
        birthday: new Date(),
        partisan: "",
        workNature: "",
        title: "",
        education: "",
        degree: "",
        idType: "",
        nationality: "",
        recommendUnitId: "",
        concernUnitId: "",
        nativeProvince: "",
        nativeCity: "",
        province: "",
        city: "",
        titleFileId: "",
        portraitId: "",
        school: "",
        major: "",
        company: "",
        socialTenure: "",
        idNumber: "",
        workMajor: "",
        jobPerformance: "",
        fullAddress: "",
        zipcode: "",
        email: "",
        mobile: "",
        telephone: "",
        experience: "",
        achievement: "",
        awards: "",
      },
      branchList: [],
      customDataList: {},
      member: {},
      fields: [],
    };
  },
  components: {
    vHead,
    memberPostTable,
    AdvancedForm,
    researchProjects,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [NavBar.name]:NavBar,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Dialog.name]:Dialog
  },
  computed: {
    ...mapState([
      "memberTypeList",
      "zhichengList",
      "cityList",
      "titleList",
      "addrList",
      "branchsList",
    ]),
    ...mapGetters([
      "allDictionary",
      "GENDER",
      "POLITICAL_STATUS",
      "EDUCATION",
      "DEGREE",
      "WORK_NATURE",
      "ID_TYPE",
      "NATIONALITY",
    ]),
    titleFileId() {
      return this.$route.query && this.$route.query.titleFileId;
    },
    //会员类型名称
    memberName() {
      let id = this.params.memberType;

      if (!id) {
        return "内容";
      } else {
        let obj = this.memberTypeList.find((item) => item.memberType === id);
        return obj.dueName;
      }
    },
    gender() {
      let id = this.params.gender;
      if (!id && id !== 0) {
        return "内容";
      } else {
        let obj = this.GENDER.find((item) => item.value === id);
        if (obj) return obj.name;
      }
    },
    sheng() {
      return this.cityList.filter((item) => {
        return item.level === 1;
      });
    },
    shi: function () {
      return this.cityList.filter((item) => {
        return item.parentId === this.sheng[0].id;
      });
    },
    portraitId() {
      return this.$route.query && this.$route.query.portraitId;
    },
    titleName() {
      return this.$route.query && this.$route.query.titleName;
    },
    portraitName() {
      return this.$route.query && this.$route.query.portraitName;
    },
  },
  methods: {
    ...mapActions([
      "getDictionaryList",
      "getMemberTypeList",
      "getBranchsList",
      "getZhiChengList",
      "getCityList",
    ]),
    ...mapMutations(["setMemberInfo"]),
    onClickLeft() {
        if(!this.member.memberNo&&!this.member.memberStatus){
            Dialog.alert({
                title: '提示',
                message: '请您填写并提交入会申请表！',
            }).then(() => {
            // on close
            });
            return;
        }
        this.$router.push({ name: "MemberCenter" });
    },
    save() {
      let params = this.member;
      let valid = this.$refs["advForm"].validateForm();
      if (!valid) {
        return;
      }
      if (params.birthday) {
        params.birthday = params.birthday.substr(0, 10);
      }
      if(params.expiryDate && params.expiryDate.length==10 ){
        params.expiryDate = params.expiryDate + ' ' + '00'+":"+'00' +":"+ '00';
      }
      // if(this.portraitId){
      //    params.portraitId = this.portraitId;
      // }
      // for (let item in this.request) {
      //   if (!this.params[item] || !("" + this.params[item]).length) {
      //       Toast(this.request[item]);
      //       return;
      //   }
      // }
      registerMemberEdit(params).then((res) => {
        if (res.success) {
          this.$router.push({ name: "MemberCenter" });
        } else {
          Toast.fail("保存失败");
        }
      });
    },
    saveZc() {
      let params = this.member;
      if (params.birthday) {
        params.birthday = params.birthday.substr(0, 10);
      }
      if(params.expiryDate && params.expiryDate.length==10 ){
        params.expiryDate = params.expiryDate + ' ' + '00'+":"+'00' +":"+ '00';
      }
      // if(this.portraitId){
      //    params.portraitId = this.portraitId;
      // }
      // for (let item in this.request) {
      //   if (!this.params[item] || !("" + this.params[item]).length) {
      //       Toast(this.request[item]);
      //       return;
      //   }
      // }
      saveMembers(params).then((res) => {
        if (res.success) {
          Toast.success("保存成功");
          // this.$router.push({ name: 'MemberCenter'});
        } else {
          Toast.fail("保存失败");
        }
      });
    },
    getFields() {
      var params = {};
      if (this.member.memberType == 1) {
        //普通会员1
        params.batchType = 5;
        params.businessType = 2;
      } else if (this.member.memberType == 2) {
        //高级会员2
        params.batchType = 5;
        params.businessType = 16;
      } else {
        //学生会员3
        params.batchType = 5;
        params.businessType = 15;
      }
      getSingleRegisterSetting(params).then((resp) => {
        if (resp.success) {
          this.fields = resp.result;
        } else {
          this.$message.error(resp.message);
        }
      });
    },
  },

  mounted() {
    var obj = window.localStorage.getItem("userInfo");
    this.member = JSON.parse(obj);
    if(this.member.expiryDate){
        this.member.expiryDate = this.member.expiryDate.substr(0, 10);
    }
    this.getFields();
    getBranchs().then((res) => {
      if (res.success) {
        res.result.forEach((itm) => (itm.value = itm.code));
        this.customDataList["recommendUnitId"] = res.result;
        this.customDataList["concernUnitId"] = res.result;
        this.branchList = res.result;
      }
    });
    this.getDictionaryList();
    this.getMemberTypeList();
    this.getZhiChengList();
    //this.getBranchsList();
    this.getCityList();
  },
};
</script>

<style  lang="less" scoped>
.buttonBox {
  background: #f3f6fb;
  padding: 20px 10px;
  display: flex;
  button{
      margin:0 10px
  }
}
.base-item {
  margin-top: 10px;
}
.nextBtn {
  margin-top: 35px;
  height: 45px !important;
  line-height: 45px;
}
.base-box > p {
  font-size: 13px;
  color: #999;
  margin:20px 0 8px 0;
  margin-left: 20px;
}
.fontBox {
  font-size: 14px;
  padding:0 18px 0;
//   border-top: #f3f6fb solid 10px;
  color: #323233;
  background: #fff;
}
.fontBox thead {
  background: #f2f2f2;
}
.fontBox table td {
  font-size: 15px;
  margin: 0;
  color: #000;
  padding: 10px 0;
}
table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border-spacing: 1;
  border-spacing: 0;
}
table td {
  word-break: break-all;
  word-wrap: break-word;
  border: 1px solid #dfdfdf;
}
</style>
